import { useAppStateStore } from '@/stores/appState'
import { useAuthStore } from '@/stores/auth'
import { updateAllStores } from '@/router'

// TODO [R2-3699]: Temporary bridge for legacy Pinia stores. Remove this hook once
// dogs/account/product data is fully migrated to Vue Query, which can refetch on
// window focus via QueryClient/default query options.
export const useWindowFocusRefresh = () => {
  let inFlightRefresh: Promise<void> | null = null

  const appStateStore = useAppStateStore()
  const authStore = useAuthStore()

  const refreshOnFocus = async () => {
    if (!authStore.isAuthenticated || !appStateStore.preloaded) return

    if (inFlightRefresh) {
      await inFlightRefresh
      return
    }

    inFlightRefresh = updateAllStores()
      .catch((error) => {
        console.error('Failed to refresh stores on window focus', error)
      })
      .finally(() => {
        inFlightRefresh = null
      })

    await inFlightRefresh
  }

  const onFocus = () => {
    void refreshOnFocus()
  }

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      void refreshOnFocus()
    }
  }

  window.addEventListener('focus', onFocus)
  document.addEventListener('visibilitychange', onVisibilityChange)

  return () => {
    window.removeEventListener('focus', onFocus)
    document.removeEventListener('visibilitychange', onVisibilityChange)
  }
}
